import InputController from '@/components/inputController/index';
import { PAYMENT } from '@/constants/payment';
import FormTemplate, { THEMES } from '@/components/formTemplate';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';

function Payment({
  className,
  control,
  step,
  showForm = true,
  showHelpInfo = false,
}) {
  const { TITLE, ID, BANK_ACCOUNT } = PAYMENT;
  return (
    <div className={`payment-container ${className}`}>
      <FormTemplate
        step={step}
        titleText={TITLE}
        cyData={ID}
        theme={showForm ? THEMES.NORMAL : THEMES.LONG}
      >
        {!showForm && showHelpInfo && (
          <TextInfo
            text={PAYMENT.DESC}
            kind={TEXT_KIND.PARAGRAPH}
            color={TEXT_COLOR.GREY5}
            size={TEXT_SIZE.CAPTION2}
          />
        )}
        {showForm && (
          <InputController
            inputName={BANK_ACCOUNT.NAME}
            inputId={BANK_ACCOUNT.ID}
            control={control}
            mask={BANK_ACCOUNT.MASK}
            rules={{
              required: BANK_ACCOUNT.RULES.REQUIRED,
              validate: (fieldValue) =>
                BANK_ACCOUNT.RULES.VALIDATE.IBAN_IS_VALID.checkFunc(
                  fieldValue
                ) || BANK_ACCOUNT.RULES.VALIDATE.IBAN_IS_VALID.message,
            }}
            label={BANK_ACCOUNT.LABEL}
            info={BANK_ACCOUNT.INFO}
          />
        )}
      </FormTemplate>
      <style jsx>
        {`
          .payment-container {
            margin-bottom: 12px;
          }
        `}
      </style>
    </div>
  );
}
export default Payment;
